import { render, staticRenderFns } from "./Model20.vue?vue&type=template&id=1f4b9fbe"
import script from "./Model20.vue?vue&type=script&lang=js"
export * from "./Model20.vue?vue&type=script&lang=js"
import style0 from "./Model20.vue?vue&type=style&index=0&id=1f4b9fbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports